import entities from '../config';

export const clearHash = (hash) => {
    return hash.replace('#', '');
};

export const getEntity = (link) => {
    for (let entity of entities) {
        if (entity.link === link) {
            return entity;
        }
    }
};

export const getElementByTagName = (tag) => {
    return document.getElementsByTagName(tag)[0];
};
